import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  overflow: hidden;
`;

export const TitlePage = styled.div`
  color: white;
  font-size: 1.3rem;
  text-align: center;
  font-weight: 200;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  max-width: 620px;

  @media (max-width: 768px) {
    margin: 0px 20px;
  }

  img {
    width: 47px;
    height: 31px;
    margin-right: 28px;
  }
`;

export const DesktopDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Card = styled.div`
  background-color: white;
  padding: 2rem;
  margin: 1rem auto;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  max-width: 620px;
  box-shadow: 0px 6px 12px #00000066;

  @media (max-width: 700px) {
    margin: 1rem 0.8rem 0 0.8rem;
    height: auto;
  }

  @media (min-width: 768px) {
    border-radius: 0.5rem;
  }
`;

export const TitleCard = styled.h4`
  color: #487cf5;
  font-size: 1rem;
  font-weight: 600;
  @media (max-width: 768px) {
    text-align: left;
    margin-bottom: 0px;
  }
`;

export const Order = styled.div`
  border: 1px solid #707070;
  border-radius: 0.3rem;
  width: 226px;

  h4 {
    color: #487cf5;
    text-align: center;
    font-size: 1.2rem;
    margin: 0.3rem;
    font-weight: 550;
  }

  @media (max-width: 768px) {
    margin: 18px 0px;
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: -0.4rem;

  p {
    color: #868686;
    font-size: 0.8rem;
  }
`;

export const TextStatus = styled.span`
  color: #808080;
  font-size: 0.8rem;
  font-weight: 500;
`;

export const DesktopGridDetails = styled.div`
  @media (min-width: 500px) {
    display: flex;
    justify-content: space-between;
    margin-right: 2rem;
  }
`;

export const BoxClose = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  max-width: 620px;
  margin: 5rem auto 0 auto;

  @media(max-width: 400px) {
    grid-template-columns: 2fr 1fr;
  }

  .close {
    display: flex;
    justify-content: flex-end;
    opacity: 1;

    @media(max-width: 770px) {
      margin: 0 .5rem 0 0;
    }
  }
`;

export const CloseIcon = styled.img`
  opacity: 1;
  width: 30px;
  height: 30px;
  cursor: pointer;
`;

export const Details = styled.div`
  padding: 0 1rem;

  p {
    padding: 0 1.3rem;
  }

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

export const TitleDivision = styled.h3`
  font-size: 1.1rem;
  font-weight: 550;
  color: #707070;
`;

export const Text = styled.p`
  width: 33.33%;
  margin: 0.3rem 0;
  font-size: 14px;
  color: #707070;
  padding: 0 !important;

  p {
    color: #707070;
    font-size: 14px;
    padding: 0 !important;
  }

  @media (max-width: 768px) {
    /* display: ${(props) => (props.withoutMobile ? "block" : "flex")}; */
    /* justify-content: space-between; */
    margin: 0;
    width: 100%;
  }
`;

export const BoxStatus = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const DetailsItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 769px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
